<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="row">
    <div class="col-12 col-md-6">
      <app-input-text [control]="form.get('website')" name="profile_website" [autoFocus]="true"></app-input-text>
      <app-input-text [control]="form.get('zip')" name="profile_zip"></app-input-text>
      <app-input-text [control]="form.get('city')" name="profile_city"></app-input-text>
      @if (countries.length>0) {
        <app-input-select [options]="countries"
          [control]="form.get('country')"
          name="profile_country"
          optionLabel="name"
          optionValue="code"
        ></app-input-select>
      }
    </div>
    <div class="col-12 col-md-6">
      <div class="d-flex flex-column h-100">
        <div>
          <label>{{ "profile_logo" | i18next }}</label>
        </div>
        <div class="mb-3 mb-md-auto">
          @if (logo) {
            <img class="img-fluid img-profile-form" src="{{logo}}"  alt="" />
          }
        </div>
        @if (!logo) {
          <div class="mb-3 mb-md-auto text-align-center">
            {{ "profile_no_profile_image" | i18next }}
          </div>
        }
        <div class="mb-3 text-end">
          <input type="file" #fileInput hidden accept="image/*" (change)="getFile($event)">
          <button type="button" class="btn btn-outline-secondary btn-upload-profile" (click)="fileInput.click()">
            <i class="pi pi-upload me-2"></i>
            @if (fileName) {
              {{ fileName }}
            } @else {
              {{ "choose_profile_image_file" | i18next }}
            }
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end align-items-center align-self-center mt-3">
    <ng-content></ng-content>
    <app-button-submit [invalid]="form.invalid" [label]="submitButtonLabel"></app-button-submit>
  </div>
</form>
